import styled from 'styled-components';

import { inputBaseCss } from 'components/input/styles';

export const Input = styled.input<{ error?: string }>`
  ${inputBaseCss};
`;
